import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2609/logo.png';
import Moon from '../img/event/2609/moon.png';
import TalkBoxes from '../img/event/2609/talk-boxes.png';
import Classroom from '../img/event/2609/classroom.png';
import EventText from '../img/event/2609/event-text.png';
import GiftBox from '../img/event/2609/gift-box.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import React from 'react';
import { TextBox } from './common/TextBox';

const HomeschoolEvent202608 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      <div
        className="flex w-full items-center justify-center overflow-hidden"
        style={{
          background: 'linear-gradient(180deg, #6910AB 31%, #F9E4BB 100%)',
        }}
      >
        <div className="flex w-full flex-col px-4 py-6 sm:px-6 sm:py-10 md:px-8 md:py-14 lg:px-10 lg:py-16">
          <div className="mx-auto mb-10 flex w-full flex-col items-center justify-center">
            {/* 로고 */}
            <div className="mx-auto w-full max-w-[110px] sm:max-w-[130px] md:max-w-[150px] lg:max-w-[170px]">
              <img src={Logo} alt="젭스 영어교실" className="block w-full" />
            </div>

            {/* 메인 타이틀 이미지 */}
            <div className="mt-10 w-full max-w-[220px] sm:mt-12 sm:max-w-[260px] md:mt-16 md:max-w-[330px] lg:mt-20 lg:max-w-[400px]">
              <img
                src={Moon}
                alt="개학 전, 마지막 점검 타이밍 2학기 준비 CHECK!"
                className="block w-full"
              />
            </div>

            {/* 말풍선 이미지 */}
            <div className="mt-7 w-full max-w-[285px] sm:mt-9 sm:max-w-[360px] md:mt-11 md:max-w-[440px] lg:mt-12 lg:max-w-[500px]">
              <img
                src={TalkBoxes}
                alt="학부모 고민 문구"
                className="block w-full"
              />
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#6910AB]">
        <div className="flex w-full flex-col px-5 py-8 sm:px-8 sm:py-12 md:px-10 md:py-16 lg:py-20">
          <div className="mx-auto flex w-full flex-col items-center justify-center">
            <div className="my-6 flex flex-col items-center gap-1 text-center sm:my-10 md:my-12 md:gap-4">
              <p className="text-lg font-bold leading-relaxed text-white sm:text-xl md:text-2xl lg:text-3xl">
                우리 아이를 위한 가장 확실한
              </p>

              <p className="mt-1 text-3xl font-extrabold leading-tight text-[#FEF6C5] sm:text-4xl md:text-5xl lg:text-5xl">
                영적 &amp; 지적 투자
              </p>

              <div className="mx-auto mt-3 w-full max-w-[220px] bg-[#FEF6C5] px-2 py-2 sm:max-w-[240px] md:max-w-[300px] lg:max-w-[350px]">
                <img
                  src={Classroom}
                  alt="젭스 영어교실"
                  className="block w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#201A05]">
        <div className="m-auto flex w-full flex-col px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="m-auto flex w-full max-w-[520px] flex-col gap-5 sm:gap-7 md:max-w-[620px] md:gap-8 lg:max-w-[720px]">
            {/* 설명회 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              <div className="text-lg font-semibold text-white sm:text-xl md:text-2xl lg:text-3xl">
                하나님이 쓰실 '준비된 리더'의 비법
              </div>

              <div className="text-lg font-extrabold leading-snug text-[#F9E385] sm:text-2xl md:text-3xl lg:text-4xl">
                온라인 설명회에서 확인하세요!
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <img
                src={Online_Session}
                alt="젭스영어교실 온라인설명회"
                className="block w-full"
              />
            </div>

            {/* 버튼 */}
            <div className="mx-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <DoubleLineButton
                onClick={() => {
                  window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
                }}
                borderColor="border-white"
                bgColor="bg-gradient-to-r from-[#F9E4BB] from-[0%] to-[#F9C443] to-[37%]"
                hoverBgColor="hover:bg-black/10"
                textColor="text-black"
              >
                <div className="px-4 py-3 text-base font-bold sm:px-5 sm:py-4 sm:text-2xl md:text-3xl lg:text-4xl">
                  지금 설명회 신청하기
                </div>
              </DoubleLineButton>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 4 */}
      <div
        className="flex w-full items-center justify-center overflow-hidden"
        style={{
          background: 'linear-gradient(180deg, #F9E4BB 45%, #6910AB 74%)',
        }}
      >
        <div className="flex w-full flex-col px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="mx-auto flex w-full max-w-[720px] flex-col items-center text-center">
            {/* 상단 프로모션 라벨 */}
            <div className="rounded-full bg-gradient-to-r from-[#FF7A1A] to-[#A46EFF] px-4 py-0.5 text-base font-bold text-white sm:text-xl md:text-2xl lg:text-3xl">
              추석 맞이 특별 프로모션
            </div>

            {/* 짝꿍 이벤트 이미지 */}
            <div className="mt-4 w-full max-w-[170px] sm:mt-8 sm:max-w-[300px] md:max-w-[340px]">
              <img src={EventText} alt="짝꿍 이벤트" className="block w-full" />
            </div>

            {/* 메인 타이틀 */}
            <div className="mt-1">
              <p className="mt-2 text-base font-extrabold text-black sm:text-xl md:text-2xl lg:text-2xl">
                다함께{' '}
                <span className="text-[#6910AB]">젭스해요! ~9/30 (수)</span>
              </p>
            </div>

            {/* 선물상자 이미지 */}
            <div className="mt-8 w-full max-w-[140px] sm:max-w-[220px] md:max-w-[270px]">
              <img src={GiftBox} alt="선물상자" className="block w-full" />
            </div>

            {/* 중간 설명 */}
            <div className="mt-10 flex flex-col items-center sm:mt-12 md:mt-16">
              <p className="text-base font-medium text-white/90 sm:text-lg md:text-xl lg:text-2xl">
                소중한 사람과 함께
              </p>

              <div className="mt-2 text-center">
                <p className="bg-gradient-to-r from-[#FEE9A4] to-[#FEA720] bg-clip-text text-2xl font-black leading-snug text-transparent sm:text-3xl md:text-4xl">
                  1+1 동반 등록 시,
                </p>

                <p className="text-2xl font-black leading-snug text-[#FEF6C5] sm:text-3xl md:text-4xl">
                  풍성한 특별 할인 혜택 제공!
                </p>

                <div className="mx-auto h-[2px] w-full max-w-[310px] bg-[#FEF6C5] sm:max-w-[330px] md:max-w-[390px]" />
              </div>
            </div>

            {/* 하단 안내 */}
            <div className="mt-8 text-center text-white sm:mt-10">
              <p className="text-base font-bold sm:text-base md:text-lg lg:text-xl">
                이번 추석엔 마음도 혜택도 함께 나누세요
              </p>

              <p className="mt-5 text-sm leading-relaxed text-white/80 sm:text-base md:text-lg lg:text-xl">
                * 본 혜택은 동반 등록뿐만 아니라,
                <br />
                기존 회원의 추천을 통한 신규 등록 시에도 동일하게 적용됩니다.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full items-center justify-center bg-gray2">
        <div className="m-auto flex w-full flex-col bg-[#FFA236] px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="mx-auto w-full max-w-[520px] md:max-w-[620px] lg:max-w-[720px]">
            {/* 상단 문구 */}
            <div className="mb-4 flex flex-col items-center text-center sm:mb-5 md:mb-6">
              <p className="text-base leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                내가 할 수 있을까..?{' '}
                <span className="font-extrabold">걱정은 NO!</span>
              </p>
            </div>

            <div className="mb-8 flex flex-col items-center text-center sm:mb-10 md:mb-12">
              <p className="flex flex-col items-center gap-2 text-2xl font-extrabold leading-tight text-white sm:text-3xl md:text-4xl lg:text-5xl">
                <span className="whitespace-nowrap bg-[#6910AB] px-1.5 py-1">
                  누구나 가르치기 쉬운 영어,
                </span>

                <span className="w-fit whitespace-nowrap bg-[#6910AB] px-1.5 py-1">
                  젭스영어교실!
                </span>
              </p>
            </div>

            {/* 하단 박스 */}
            <section className="flex w-full flex-col gap-4 sm:gap-5 md:gap-6">
              <div className="grid auto-rows-fr grid-cols-1 gap-4 sm:gap-5 md:gap-6">
                <TextBox className="h-full">
                  <p className="text-base font-extrabold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                    수업 진행을 위한
                    <br />
                    <span className="text-[#6910AB]">교사용 자료 구비!</span>
                  </p>
                </TextBox>

                <TextBox className="h-full">
                  <p className="text-base font-extrabold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                    별도의 과제 제작 필요 없이
                    <br />
                    <span className="text-[#6910AB]">
                      ‘과제 내주기’만으로 운영 가능!
                    </span>
                  </p>
                </TextBox>

                <TextBox className="h-full">
                  <p className="text-base font-extrabold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                    <span className="text-[#6910AB]">
                      업그레이드 된 ‘젭스온'
                    </span>
                    으로
                    <br />
                    복습까지 완벽하게!
                  </p>
                </TextBox>
              </div>
            </section>

            <div className="m-auto flex w-full flex-col px-0 pb-0 pt-10 sm:pt-12 md:pt-14 lg:pt-16">
              <p className="text-center text-base font-extrabold text-black sm:text-xl md:text-2xl lg:text-3xl">
                편리한 관리와 안정적인 시스템!
                <br />
                젭스영어교실로
                <br />
                모두가 만족하는 영어학습 시작하세요!✨
              </p>

              {/* 버튼 */}
              <div className="mx-auto mt-8 w-full max-w-[360px] sm:mt-10 sm:max-w-[520px] md:mt-12 md:max-w-[640px]">
                <DoubleLineWithCursorButton
                  onClick={() => {
                    window.open(
                      'https://jebs.kr/shop/details/NKyRTHjIgiewcumT',
                    );
                  }}
                  bgColor="bg-black"
                  hoverBgColor="hover:bg-black/70"
                  textColor="text-white"
                >
                  <div className="px-4 py-3 text-base font-bold sm:px-6 sm:py-4 sm:text-2xl md:text-3xl lg:px-8 lg:py-5 lg:text-3xl">
                    9월 젭스영어교실&nbsp;
                    <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
                  </div>
                </DoubleLineWithCursorButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202608;
